import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import TransparentHeader from "../components/global/TransparentHeader";
import BaseLayout from "../components/global/BaseLayout";
import ValuesOne from "../components/values/Values_1";
import BlockPrincipal from "../components/block/Block_6";
import BlockSecondary from "../components/block/Block_1";

function About() {
  const { rpdata } = useContext(GlobalDataContext);
  return (
    <BaseLayout PageName="About">
      <div className="md:max-w-full w-full">
        <TransparentHeader
          headertitle="About"
          Subheader="About"
          bgimg={`${rpdata?.gallery?.length > 10 ? rpdata?.gallery[10] : rpdata?.stock?.[10]}`}
        />
        <BlockPrincipal
          title={'a little about us'}
          subtitle2={rpdata?.dbSlogan?.[3]?.slogan}
          text={rpdata?.dbAbout?.[0]?.text}
          image1={rpdata?.gallery?.length > 6 ? rpdata?.gallery[6] : rpdata?.stock?.[6]}
          image2={rpdata?.gallery?.length > 7 ? rpdata?.gallery[7] : rpdata?.stock?.[7]}
          image3={rpdata?.gallery?.length > 2 ? rpdata?.gallery[2] : rpdata?.stock?.[2]}
          image4={rpdata?.gallery?.length > 9 ? rpdata?.gallery[9] : rpdata?.stock?.[9]}
          listAbout={true}
        />
        <ValuesOne
          image={rpdata?.gallery?.[3]}
          image2={rpdata?.gallery?.[0]} />

        <BlockSecondary
          title={rpdata?.dbSlogan?.[2]?.slogan}
          text={rpdata?.dbAbout?.[1]?.text}
          image={rpdata?.gallery?.length > 5 ? rpdata?.gallery[5] : rpdata?.stock?.[5]}

        />
      </div>
    </BaseLayout>
  );
}

export default About;
